module.exports = __webpack_public_path__ + "media/icons/document-text-67d834b0.svg";